"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.apiFetch = void 0;
const js_cookie_1 = __importDefault(require("js-cookie"));
const _params_1 = require("@params");
/**
 * Thin wrapper around fetch() that applies the standard API defaults:
 *   - Prepends `apiHost` to the path
 *   - Sets `credentials: 'include'`
 *   - Sets `Content-Type: application/json` and `X-CSRFToken`
 *
 * Returns the raw Response so callers can do `.json()`, read headers, etc.
 */
function apiFetch(path, options) {
    const _a = options || {}, { headers: extraHeaders } = _a, rest = __rest(_a, ["headers"]);
    return fetch(`${_params_1.apiHost}${path}`, Object.assign(Object.assign({ credentials: 'include' }, rest), { headers: Object.assign({ 'Content-Type': 'application/json', 'X-CSRFToken': js_cookie_1.default.get('csrftoken') || '' }, extraHeaders) }));
}
exports.apiFetch = apiFetch;
